import clickableBlock from './features/clickable-block';
import registerFloatingCTA from './features/register-floating-cta';
import trackTypeOfView from './helpers/tracking/type-of-view';

clickableBlock('.js-wio-list-condensed', '.wio__item');
registerFloatingCTA('.js-register-floating-cta');
trackTypeOfView();
